// Colores de los pasos del ciclo de vida (Paleta B), compartidos por el
// stepper de la ficha de la obra (ciclo-vida.tsx) y el ciclo estático de la
// card del mosaico del Avivador v2 (components/avivador/ciclo-estatico.tsx).
// Viven en un .ts propio para que los dos .tsx sigan exportando solo
// componentes (regla de Fast Refresh).
//
// Paleta B (punto 15 de la validación v0.9.0, hex cerrados por el panel de
// accesibilidad — ver context/design_validacion_v080_feedback.md): aprobado
// y facturado dejan de pisarse sobre --success/foreground genéricos y pasan
// a tokens propios (--aprobado/--facturado + sus *-foreground), registrados
// en index.css. Salto/entrega/póliza ya venían con AA correcto en sus
// tokens actuales (accent-strong/info/warning) — sin cambios acá, la mejora
// de esos tres sale de los valores nuevos de --info/--warning en index.css.
import type { StepColor } from '@/components/rdt/rdt-domain';

// RedeApp R0 (§2.c): Entrega y Póliza dejan de pisar --info/--warning
// genéricos y pasan a los pares propios --entrega/--poliza (mismos valores
// hoy, mismo patrón que --aprobado/--facturado).
// O3 de la QA de la rc.6 (Juan, 28/9, variante C): Salto usa el relleno
// sólido naranja con el tilde BLANCO (--primary-solid, #d96d0e en los dos
// temas), como botones y checkbox; antes, --accent-strong con el tilde oscuro.
/** Círculo de un paso HECHO: borde + relleno del color del paso y el tilde
 *  en su *-foreground (en «Entrega», `text-entrega-foreground`: D-12 del
 *  relevamiento de la card). */
export const STEP_COLOR_CLASS: Record<StepColor, string> = {
  salto: 'border-primary-solid bg-primary-solid text-primary-solid-foreground',
  entrega: 'border-entrega bg-entrega text-entrega-foreground',
  aprobado: 'border-aprobado bg-aprobado text-aprobado-foreground',
  poliza: 'border-poliza bg-poliza text-poliza-foreground',
  facturado: 'border-facturado bg-facturado text-facturado-foreground',
};

/** Conector hacia el paso de la derecha cuando ese paso está hecho: el color
 *  del paso izquierdo al 55 %. */
export const CONN_DONE_CLASS: Record<StepColor, string> = {
  salto: 'bg-primary-solid opacity-55',
  entrega: 'bg-entrega opacity-55',
  aprobado: 'bg-aprobado opacity-55',
  poliza: 'bg-poliza opacity-55',
  facturado: 'bg-facturado opacity-55',
};
